module.exports = __webpack_public_path__ + "static/media/dec2024-4.06faf656.webp";